import React, { useState } from 'react';
import authService from '../../services/authService';

const MfaChallenge = ({ email, password, rememberMe, tempToken, onSuccess, onError }) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [useRecoveryCode, setUseRecoveryCode] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!code.trim()) {
      setError('Please enter a verification code');
      return;
    }

    if (!tempToken) {
      setError('Invalid session. Please log in again.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Complete login with MFA verification
      await authService.loginWithMfa(tempToken, code.trim());
      
      onSuccess();
    } catch (err) {
      const errorMessage = err.message || 'Invalid verification code';
      setError(errorMessage);
      if (onError) {
        onError(err);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '0 auto', padding: '20px' }}>
      <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '8px', textAlign: 'center' }}>
        Multi-Factor Authentication
      </h2>
      <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '24px', textAlign: 'center' }}>
        {useRecoveryCode 
          ? 'Enter one of your recovery codes' 
          : 'Enter the verification code from your authenticator app'}
      </p>

      {error && (
        <div style={{
          padding: '12px 16px',
          backgroundColor: '#fef2f2',
          border: '1px solid #fecaca',
          borderRadius: '8px',
          color: '#991b1b',
          marginBottom: '16px',
          fontSize: '14px'
        }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: 500, marginBottom: '8px' }}>
            {useRecoveryCode ? 'Recovery Code' : 'Verification Code'}
          </label>
          <input
            type="text"
            value={code}
            onChange={(e) => {
              const value = useRecoveryCode 
                ? e.target.value 
                : e.target.value.replace(/\D/g, '').slice(0, 6);
              setCode(value);
            }}
            placeholder={useRecoveryCode ? 'Enter recovery code' : '000000'}
            maxLength={useRecoveryCode ? undefined : 6}
            autoFocus
            style={{
              width: '100%',
              padding: '12px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '18px',
              textAlign: 'center',
              letterSpacing: useRecoveryCode ? 'normal' : '4px',
              fontFamily: 'monospace'
            }}
          />
        </div>

        <button
          type="submit"
          disabled={loading || !code.trim()}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: (loading || !code.trim()) ? '#9ca3af' : '#667eea',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: 600,
            cursor: (loading || !code.trim()) ? 'not-allowed' : 'pointer',
            marginBottom: '12px'
          }}
        >
          {loading ? 'Verifying...' : 'Verify'}
        </button>

        <button
          type="button"
          onClick={() => {
            setUseRecoveryCode(!useRecoveryCode);
            setCode('');
            setError(null);
          }}
          style={{
            width: '100%',
            padding: '8px',
            backgroundColor: 'transparent',
            color: '#667eea',
            border: 'none',
            fontSize: '14px',
            cursor: 'pointer',
            textDecoration: 'underline'
          }}
        >
          {useRecoveryCode ? 'Use authenticator app instead' : 'Use recovery code instead'}
        </button>
      </form>
    </div>
  );
};

export default MfaChallenge;

